import React, { useState } from "react";
import { Link } from "react-router-dom";

function Navbar({ setShowModal }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-gray-800 shadow-md fixed top-0 left-0 w-full z-[9999]">
      <div className="flex items-center justify-between px-4 md:px-8 py-4 relative w-full">
        
        {/* Left: Hamburger + Logo */}
        <div className="flex items-center space-x-4">
          {/* Hamburger Icon (Mobile Only) */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-white text-3xl focus:outline-none md:hidden"
          >
            ☰
          </button>

          {/* Logo */}
          <div className="text-2xl md:text-2xl font-bold text-purple-400">Hey There!!!</div>
        </div>

        {/* Center: Navigation (Desktop Only) */}
        <div className="hidden md:flex absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 items-center space-x-4 md:space-x-6 text-base md:text-xl">
          <Link to="/" className="text-gray-300 hover:text-purple-400">Home</Link>
          <Link to="/about" className="text-gray-300 hover:text-purple-400">About</Link>

          {/* Projects Dropdown */}
          <div className="relative group inline-block">
            <Link 
              to="/projects" 
              className="text-gray-300 hover:text-purple-400 inline-block"
            >
              Projects ▼
            </Link>
            <div className="absolute left-1/2 transform -translate-x-1/2 top-full mt-0 bg-gray-700 rounded-lg shadow-lg py-4 w-48 md:w-64 z-50 text-center opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300 ease-in-out">
              {[
                { path: "maplee-market-place", label: "Maplee Market Place" },
                { path: "previous-maplee", label: "(Previous) Maplee" },
                { path: "facial-recognition", label: "Facial Recognition" },
                { path: "facebook-post-ml-analysis", label: "Facebook ML Analysis" },
                { path: "boggle-algorithms", label: "Boggle Algorithms" },
                { path: "data-analysis-of-student-responses", label: "Student Responses" },
                { path: "image-generation", label: "Image Generation" },
                { path: "paper-trading", label: "Paper Trading" },
                { path: "gym-database", label: "Gym Database" },
                { path: "club-finance-app", label: "Club Finance App" },
              ].map(({ path, label }) => (
                <Link
                  key={path}
                  to={`/projects/${path}`}
                  className="block px-4 py-2 text-gray-300 hover:bg-gray-600 hover:text-purple-400 rounded transition-colors duration-300"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <Link to="/contact" className="text-gray-300 hover:text-purple-400">Contact</Link>
        </div>

        {/* Right: Let's Talk */}
        <button
          onClick={() => setShowModal(true)}
          className="bg-purple-600 text-white px-4 py-2 md:px-6 md:py-3 rounded-full hover:bg-purple-700 transition text-sm md:text-base"
        >
          Let's Talk
        </button>
      </div>

      {/* Mobile Menu (below navbar) */}
      {mobileMenuOpen && (
        <div className="w-full bg-gray-900 flex flex-col items-center space-y-3 py-4 text-white text-base md:hidden">
          <Link to="/" className="hover:text-purple-400" onClick={() => setMobileMenuOpen(false)}>Home</Link>
          <Link to="/about" className="hover:text-purple-400" onClick={() => setMobileMenuOpen(false)}>About</Link>
          <Link to="/projects" className="hover:text-purple-400" onClick={() => setMobileMenuOpen(false)}>Projects</Link>
          <Link to="/contact" className="hover:text-purple-400" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
        </div>
      )}
    </nav>
  );
}

export default Navbar;